import { type ReactNode } from 'react';

export const OpenFormItem = ({ children, title }: { children?: ReactNode; title?: ReactNode }) =>
  !children && !title ? null : (
    <div className="of-openform__list-item">
      {title ? <dt className="of-openform__list-item--title">{title}</dt> : null}
      {children ? <dd className="of-openform__list-item--data">{children}</dd> : null}
    </div>
  );
